import { EntityType } from '@lib/deals';
import {
  Avatar,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { EntityIcon } from './entity-type-icon';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useState } from 'react';
import CopyClipboard from '@material-ui/icons/AttachFile';
import { isNull } from 'lodash';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export const EntityNameColumn = ({
  type,
  name,
  vtrId = null,
  secondary = null,
  iconProps = {},
  hideTooltip = false,
  secondaryTypographyProps = {},
  overrideAvatar = null,
  avatarImg = null,
}) => {
 // console.log('avatarImg', avatarImg);
  const classes = useStyles();
  const entity = (
    <ListItem style={{ padding: 0 }} component="div">
      <ListItemAvatar style={{ display: 'flex', minWidth: 0, marginRight: 6 }}>
        {avatarImg ? (
          <Avatar
            src={avatarImg}
            className={[
              classes.containedImage,
              // , classes.large
            ].join(' ')}
          />
        ) : (
          <EntityIcon noTooltip type={overrideAvatar || type} {...iconProps} />
        )}
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant="body1" display="block" style={{fontWeight:500}}>
            <ClipBoard
              parentValue={name}
              icon={<CopyClipboard style={{ fontSize: '1.2em' }} color="primary" />}
              value={vtrId ? vtrId : 'No Vitrina ID associated'}
            />
          </Typography>
          
        }
        
        secondary={secondary}
        secondaryTypographyProps={secondaryTypographyProps}
      />
      
    </ListItem>
    
  );
  return hideTooltip ? entity : <Tooltip title={type}>{entity}</Tooltip>;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentImg: {
      width: '40px',
      height: '75px',
      marginRight: '5px',
    },
    containedImage: {
      '& .MuiAvatar-img': {
        objectFit: 'contain',
        // border: '1px solid lightgray',
        // backgroundColor: 'lightgray',
      },
    },
  })
);

function ClipBoard({ parentValue, icon, value }) {
  const [isHovering, setHovering] = useState(false);
  const [isClick, setClick] = useState(false);
  return (
    <>
      <span
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => {
          setClick(false);
          setTimeout(() => {
            setHovering(false);
          }, 5000);
        }}>
        {parentValue}
      </span>
      <span
        style={{
          color: 'inherit',
          fontSize: 11,
          display: isHovering ? 'inline' : 'none',
          alignItems: 'center',
          paddingTop: '2px',
        }}>
        <Tooltip
          title={isClick ? 'Copied!!' : 'Copy the Vitrina Id'}
          // arrow
          // followCursor
          onClick={() => {
            navigator.clipboard.writeText(value);
            setClick(true);
          }}>
          {icon}
        </Tooltip>
      </span>
    </>
  );
}
